import "./Confirm.css";
import { useNavigate } from "react-router-dom";
import LogoDownload from "../../assets/LogoDownload.png";
import LogoDownloadFooter from "../../assets/LogoDownloadFooter.svg";
import backgroundSquareDownload from "../../assets/backgroundSquareDownload.webp";
import navExtIcon from "../../assets/navExtIcon.svg";

export default function ConfirmPayment() {
    const navigate = useNavigate();

    const formatLicense = (license) => {
        if (license === "free") {
            return "Free";
        } else if (license === "masterMonthly") {
            return "Master Monthly";
        } else if (license === "masterYearly") {
            return "Master Yearly";
        } else {
            return "Something went wrong...";
        }
    };

    const urlParams = new URLSearchParams(window.location.search);
    const plan = urlParams.get("plan") || "free";
    const formatedPlan = formatLicense(plan);

    return (
        <>
            <title>Payment Succesful | Oakmate</title>
            <meta name="description" content="Enjoy the Oakmate Master plan." />
            <div className="confirmPage">
                <img
                    src={backgroundSquareDownload}
                    alt="Background"
                    className="backgroundSquareDownload"
                />

                <div className="download-container">
                    <div className="main-wrapper">
                        <div
                            className="logo-wrapper"
                            onClick={() => navigate("/")}
                        >
                            <img
                                src={LogoDownload}
                                alt="Logo"
                                className="LogoConfirm"
                            />
                        </div>
                        <div className="text-wrapper">
                            <div className="text-title">You're all set!</div>
                            <div className="text-sub">
                                Account Upgraded to {formatedPlan}
                            </div>
                        </div>
                        <button
                            className="download-cta"
                            onClick={() => {
                                window.open(
                                    "https://www.chess.com/home",
                                    "_blank"
                                );
                            }}
                        >
                            <div className="download-cta-text">
                                Back to Chess.com
                            </div>
                            <img
                                src={navExtIcon}
                                className="download-cta-icon"
                                alt="Download Icon"
                            />
                        </button>
                    </div>
                </div>

                <div className="copyright">
                    Copyright © 2025 Oakmate. All rights reserved
                </div>
                <div className="oakmatebackgroundlogo-wrapper">
                    <img
                        src={LogoDownloadFooter}
                        alt="Logo background"
                        className="LogoDownloadFooter"
                    />
                    <div className="maskdownloadfooter" />
                </div>
            </div>
        </>
    );
}
